import { ClientType } from "@store/graphql/helpers/types.graphql";
import { atomWithReset, useAtom, useResetAtom } from "@libraries/jotai";

const clientsAtom = atomWithReset<ClientType[]>([]);
const filteredClientsAtom = atomWithReset<ClientType[]>([]);

export default function useClients() {

  const [value, setValue] = useAtom(clientsAtom);
  const reset = useResetAtom(clientsAtom);

  const [filteredClients, setFilteredClients] = useAtom(filteredClientsAtom);
  const resetFilteredClients = useResetAtom(filteredClientsAtom);

  return {
    value,
    setValue,
    reset,
    filteredClients,
    setFilteredClients,
    resetFilteredClients
  };
}
